import { StapleTableCell } from '@insurancemenu/imenu-components-lib';
import { TooltipWrapperStyled } from '@insurancemenu/imenu-components-lib/dist/components/Tooltip/styles';
import styled from 'styled-components';

export const ActionCellStyled = styled(StapleTableCell)`
  text-align: right;
`;
export const ProposalNameWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  & > ${TooltipWrapperStyled} {
    display: block;
    width: unset;
    height: 2rem;
  }
`;
